import { Loader } from "@components/crud/Loader";
import { Grid, Typography } from "@mui/material";
import { useAdminSettingsPut } from "@sportsgravyengineering/sg-api-react-sdk";
import { organizationAtom, organizationsAtom } from "@recoil/auth";
import { useAdminSettingsGet } from "@sportsgravyengineering/sg-api-react-sdk";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useRecoilState, useRecoilValue } from "recoil";
import { enqueueSnackbar } from "notistack";
import { FormSelect } from "@components/FormSelect";
import { hasPermission } from "@services/Casbin";
export const TeamsProgramsSettings = () => {
  const form = useForm({
    mode: "onBlur"
  });
  const [organizationId] = useRecoilState(organizationAtom);
  const [disabled, setDisabled] = useState(false);
  const { data: settings, isLoading: isLoading } = useAdminSettingsGet({
    organizationId: organizationId!,
    parentId: "org-teams-programs"
  });
  const { reset, control, getValues } = form;
  useEffect(() => {
    if (settings) {
      const settingsMap = settings.data.map((setting) => {
        return {
          settingId: setting.settingId,
          value:
            setting.organizationSettings && setting.organizationSettings.length
              ? setting.organizationSettings[0].value
              : setting.default
        };
      });
      const defaultValues = {
        selectedSettings: settingsMap
      };
      reset(defaultValues, {
        keepDefaultValues: false
      });
    }
  }, [settings]);

  useEffect(() => {
    const checkPermission = async (permissionId, permission) => {
      const res = await hasPermission(
        "ORGANIZATION",
        organizationId!,
        permissionId as string,
        permission as string
      );
      return res;
    };
    const fetchPermissions = async () => {
      const edit = await checkPermission("admin.settings", "EDIT");
      setDisabled(!edit);
    };
    fetchPermissions();
  }, []);
  const { mutate: save, isLoading: isSaving } = useAdminSettingsPut();
  const onSave = () => {
    const data = getValues().selectedSettings;
    save(
      {
        data: data,
        params: {
          organizationId: organizationId!
        }
      },
      {
        onSuccess: () => {
          enqueueSnackbar("Saved Successfully!", {
            variant: "success"
          });
        },
        onError: () => {
          enqueueSnackbar("Failed to save !", {
            variant: "error"
          });
        }
      }
    );
  };

  const organizations = useRecoilValue(organizationsAtom);
  const org = organizations.find((o) => o.organizationId === organizationId);

  const getSettingView = (settingId) => {
    const index = settings?.data.findIndex(
      (setting) => setting.settingId === settingId
    );
    if (index !== undefined && index !== -1) {
      const setting = settings!.data[index];
      switch (setting.type) {
        case "SINGLE_SELECT":
          return (
            <Grid item container direction="row">
              <Grid item xs={6} data-testid={setting.settingId}>
                <FormSelect
                  disabled={disabled}
                  control={control}
                  onChange={() => {
                    onSave();
                  }}
                  name={`selectedSettings[${index}].value`}
                  options={
                    setting.options as { label: string; value: string }[]
                  }
                  label={setting.description}
                />
              </Grid>
            </Grid>
          );
      }
    }
    return <></>;
  };

  return (
    <Grid
      item
      container
      direction="column"
      spacing="15px"
      data-testid="training-program-setting"
    >
      <Loader isLoading={isSaving || isLoading}>
        {settings && org?.offering?.includes("TEAM") && (
          <Grid item container direction="column" spacing="10px">
            <Grid item>
              <Typography
                variant="permissionNames"
                sx={{
                  color: "#00000",
                  fontSize: "12px",
                  font: "inter",
                  lineHeight: "14.52px",
                  letterSpacing: "10%",
                  fontWeight: 400
                }}
              >
                TEAMS
              </Typography>
            </Grid>
            {getSettingView("org-teams-programs.add-override-teams")}
          </Grid>
        )}
        {settings && org?.offering?.includes("TRAINING_PROGRAM") && (
          <Grid item container direction="column" spacing="10px">
            <Grid item>
              <Typography
                variant="permissionNames"
                sx={{
                  color: "#00000",
                  fontSize: "12px",
                  font: "inter",
                  lineHeight: "14.52px",
                  letterSpacing: "10%",
                  fontWeight: 400
                }}
              >
                TRAINING PROGRAMS
              </Typography>
            </Grid>
            {getSettingView("org-teams-programs.add-override-programs")}
          </Grid>
        )}
      </Loader>
    </Grid>
  );
};
